import { DynamicPageProps } from 'types/DynamicPageProps';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import { BannerProps } from 'types/InputsGridOfBannersProps';

export function returListOptionsDynamicPage(
	listPages: DynamicPageProps[]
): SelectInputItemProps[] {
	const listOptions: SelectInputItemProps[] = [];

	listPages.forEach((item) => {
		listOptions.push({ id: item.id, option: item.name });
	});

	return listOptions;
}

export function verifyIfFormCanSave(
	dataForm: BannerProps,
	setDataForm: React.Dispatch<React.SetStateAction<BannerProps>>,
	useVideo: boolean,
	handleNotify: any
) {
	if (dataForm.name === '') {
		handleNotify('Preenha o campo "Título"', 'error');
		return false;
	}

	if (useVideo) {
		if (dataForm.reference_value === '') {
			handleNotify('Preenha o campo "Url do vídeo"', 'error');
			return false;
		}
	} else {
		if (dataForm.file_id === '') {
			handleNotify('Suba a imagem do banner', 'error');
			return false;
		}
	}

	if (dataForm.width <= 0) {
		handleNotify('O campo "Largura" deve ser maior que 0 ', 'error');
		return false;
	}

	if (dataForm.width > 100) {
		handleNotify('O valor máximo do campo "Largura" é 100%', 'error');
		return false;
	}

	if (dataForm.height === '' || parseInt(dataForm.height) === 0) {
		handleNotify('Preenha o campo "Altura"', 'error');
		return false;
	}

	if (dataForm.redirect_value === '') {
		handleNotify('Preenha o campo "Valor do redirecionamento"', 'error');
		return false;
	}

	if (!dataForm.has_modal) {
		setDataForm((obj) => ({
			...obj,
			modal: {
				...obj.modal,
				file_id: '',
				file_path: '',
				height: '',
				redirect_type: '',
				redirect_value: ''
			}
		}));
	}

	if (useVideo) {
		setDataForm((obj) => ({
			...obj,
			file_id: '',
			file_path: ''
		}));
	} else {
		setDataForm((obj) => ({
			...obj,
			reference_value: ''
		}));
	}

	return true;
}
